import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { navItems } from './navItems'

export const useActiveNav = () => {
  const location = useLocation()
  const [activeMainNav, setActiveMainNav] = useState<string | null>(null)

  useEffect(() => {
    const path = location.pathname

    if (path.startsWith('/about')) setActiveMainNav('ABOUT US')
    else if (path.startsWith('/programmes')) setActiveMainNav('PROGRAMMES & PRIORITIES')
    else if (path.startsWith('/opportunities')) setActiveMainNav('OPPORTUNITIES')
    else if (path.startsWith('/media')) setActiveMainNav('MEDIA')
    else if (path.startsWith('/events')) setActiveMainNav('EVENTS')
    else if (path.startsWith('/resources')) setActiveMainNav('RESOURCES')
    else setActiveMainNav('HOME')
  }, [location.pathname])

  const getActiveSubNav = () => {
    const active = navItems.find(n => n.title === activeMainNav)
    return active?.subItems || []
  }

  const defaultRouteMap: Record<string, string> = {
    '/about': '/about/who-we-are',
    '/programmes': '/programmes',
    '/opportunities': '/opportunities/procurement'
  }

  const isSubItemActive = (subItemHref: string) => {
    const path = location.pathname

    if (path === subItemHref) return true
    if (path.startsWith(subItemHref + '/')) return true

    const defaultHref = defaultRouteMap[path]
    if (defaultHref && defaultHref === subItemHref) return true

    return false
  }

  return {
    activeMainNav,
    getActiveSubNav,
    isSubItemActive
  }
}